import React, { useEffect, useState, useCallback } from "react";
import SummaryHeader from "./SummaryHeader";
import SummaryFooter from "./SummaryFooter";
import QuoteSummaryContent from './QuoteSummaryContent';
import { useLocation, useNavigate } from "react-router-dom";
import LoaderModal from '../BBAdmin/Components/Loader';

const SummaryPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quotationData, setQuotationData] = useState(null);
  const [mockData, setMockData] = useState({
    packageData: {},
    totalPrice: { total: 0, subtotal: 0, tax: 0 }
  });
  const [showOrderConfirmation, setShowOrderConfirmation] = useState(false);
  const [orderMessage, setOrderMessage] = useState("");

  // Safely extract location state with defaults
  const {
    product_category_name = '',
    product_category_id = '',
    project_id = '',
    package_id = '',
    quotation_id = '',
    projectName = ''
  } = location.state || {};

  const fetchUrl = process.env.REACT_APP_FORE_APILINK;

  // Transform quotation data to mock data


  // Fetch quotation data
  const fetchQuotationSummary = useCallback(async () => {
    if (!product_category_id || !project_id) {
      setError('Missing required parameters');
      setIsLoading(false);
      return;
    }

    const queryParams = new URLSearchParams({
      product_category_id,
      project_id,
      package_id,
      quotation_id
    }).toString();

    try {
      setIsLoading(true);
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 30s timeout

      const response = await fetch(`${fetchUrl}/summary/get-quote-summary?${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorMessages = {
          400: 'Invalid request parameters',
          401: 'Unauthorized access',
          403: 'Access forbidden',
          404: 'Quotation not found',
          500: 'Internal server error'
        };

        const errorMessage = errorMessages[response.status] || 'Failed to fetch quotation';
        throw new Error(errorMessage);
      }

      const data = await response.json();
      console.log(data)
      const transformedData = {
        packageData: {
          packageName: data.quote_type || 'Standard',
          reference: data.referance || 'N/A',
          category: data.product_category_name || product_category_name || '',
          projectName: data.project_name || ''
        },
        totalPrice: {
          total: Number(data.total) || 0,
          subtotal: Number(data.subtotal) || 0,
          tax: Number(data.tax_amount) || 0
        }
      };
      setMockData(transformedData);
      if (!data || typeof data !== 'object') {
        throw new Error('Invalid data received from server');
      }

      setQuotationData(data);
      setError(null);

    } catch (error) {
      console.error('Quotation fetch error:', error);
      setError(error.message);
      
      if (error.name === 'AbortError') {
        setError('Request timeout - please try again');
      }

    } finally {
      setIsLoading(false);
    }
  }, [fetchUrl, product_category_id, project_id, package_id, quotation_id]);
  console.log(mockData)

  useEffect(() => {
    fetchQuotationSummary();
  }, [fetchQuotationSummary]);

  const handleUpdateQuoteSelectionStatus = async () => {
    const token = sessionStorage.getItem('token');
    const BRICKBUCKET = process.env.REACT_APP_FORE_BRICKBUCKET;
    const queryParams = new URLSearchParams({
      product_category_id,
      project_id,
      package_id,
      quotation_id
    }).toString();
    try {
      const response = await fetch(`${BRICKBUCKET}customer/quotations/update-quote-selection-status?${queryParams}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify({
          product_category_id:product_category_id,
          project_id: project_id,
          package_id:package_id,
          quotation_id:quotation_id,
          status: 'Selected'
        })
      });
  
      const data = await response.json();
      console.log(data)
  
      if (response.ok) {
        // Handle success
       // setQuotationStatus('Selected');
      
       // Navigate after a delay
         navigate('/consumer/app/home');
        return data;
      } else {
        throw new Error(data.message || 'Failed to update status');
      }
  
    } catch (error) {
      console.error('Error updating quotation status:', error);
      throw error;
    }
  };

  const handleConvertQuotationToOrder = async () => {
    setShowOrderConfirmation(true);

    // Get token from session storage
    const token = sessionStorage.getItem('token');
    
    // Get user data from session storage
    const sessionData = {
      username: sessionStorage.getItem('username'),
      hubId: sessionStorage.getItem('hubId'),
      userId: sessionStorage.getItem('userId'),
      customer_id: sessionStorage.getItem('customer_id')
    };
    
    const BRICKBUCKET = process.env.REACT_APP_FORE_BRICKBUCKET;
    
    // Create query params
    const queryParams = new URLSearchParams({
      product_category_id,
      project_id,
      package_id,
      quotation_id
    }).toString();
    
    try {
      const response = await fetch(`${BRICKBUCKET}customer/salesorder/convert-quotation-to-salesOrder?${queryParams}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify({
          product_category_id: product_category_id,
          project_id: project_id,
          package_id: package_id,
           quotation_id: quotation_id, 
          status: 'Selected',
          // Include user information from session storage
          username: sessionData.username || '',
          hubId: sessionData.hubId || '',
          userId: sessionData.userId || '',
          customer_id: sessionData.customer_id || ''
        })
      });
      
      const data = await response.json();
      console.log(data)
      
      if (response.ok) {
        console.log('Quotation converted to order successfully');
        // Handle success
        // setQuotationStatus('Selected');
        setTimeout(() => {
          setShowOrderConfirmation(false);
          navigate('/consumer/app/home');
        }, 3000);
        return data;
      } else {
        if (data.message === "Sales order with this quotation number already exists") {
          console.log('Order already exists');
          setOrderMessage("Your order has already been placed");
          setTimeout(() => {
            setShowOrderConfirmation(false);
          }, 3000);
        } else {
          console.log('Quotation conversion failed');
          setOrderMessage("Failed to place order");
          setShowOrderConfirmation(false);
        }
      }
    } catch (error) {
      console.error('Error updating quotation status:', error);
      setShowOrderConfirmation(false);
      throw error;
    }
  };
  
  
  

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center p-8 bg-white rounded-xl shadow-lg">
          <h2 className="text-xl font-bold text-red-600 mb-4">Error Loading Summary</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {isLoading ? (
        <LoaderModal 
          isVisible={true}
          title="Loading Summary"
          packageName="Please wait..."
        />
      ) : (
        <>
        {mockData?.packageData && (
          <SummaryHeader
          packageData={mockData.packageData}
          totalPrice={mockData.totalPrice}
        />
        )}
         {quotationData && (
        <QuoteSummaryContent 
        quotationData={quotationData} 
        onInterested={() => {
          handleUpdateQuoteSelectionStatus();
        }}
        onPlaceOrder = {() => {
          handleConvertQuotationToOrder();
        }}
        />
         )}         
          <SummaryFooter
          onCallBack={() => {
            //console.log('Callback requested');
          }}
          onInterested={() => {
            handleUpdateQuoteSelectionStatus();
          }}
        />

        </>
      )}
      
      {showOrderConfirmation && (
  <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center p-4 z-[100]">
    <div className="bg-white rounded-2xl max-w-xs w-full p-8 shadow-2xl" style={{animation: "fadeInDown 0.4s ease-out"}}>
      <div className="flex flex-col items-center text-center">
        {orderMessage === "Your order has already been placed" ? (
          // Order already exists - new design
          <>
            <div className="w-20 h-20 relative mb-5 flex items-center justify-center">
              <div className="absolute w-full h-full rounded-full bg-amber-50 animate-pulse"></div>
              <div className="relative z-10">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center border-2 border-amber-400">
                  <svg className="w-8 h-8 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                  </svg>
                </div>
              </div>
            </div>
            <h2 className="text-xl font-bold text-amber-700">Already Ordered</h2>
            <p className="mt-2 text-gray-600">This quotation has already been converted to an order in our system.</p>
            <div className="mt-4 p-3 bg-amber-50 rounded-lg border border-amber-200">
              <p className="text-sm text-amber-800">You can view your existing order in the Orders section of your dashboard.</p>
            </div>
            <button 
              onClick={() => {
                setShowOrderConfirmation(false);
                navigate('/consumer/app/orders');
              }}
              className="mt-5 px-5 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg transition-colors"
            >
              View My Orders
            </button>
          </>
        ) : orderMessage === "Failed to place order" ? (
          // Error popup
          <>
            <div className="w-18 h-18 relative mb-5">
              <div className="absolute inset-0 bg-red-100 rounded-full animate-ping opacity-25"></div>
              <div className="relative w-16 h-16 bg-white rounded-full flex items-center justify-center border-2 border-red-400">
                <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </div>
            </div>
            <h2 className="text-xl font-bold text-gray-800">Order Failed</h2>
            <p className="mt-2 text-gray-600">There was a problem placing your order. Please try again.</p>
            <button 
              onClick={() => setShowOrderConfirmation(false)}
              className="mt-5 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 transition-colors"
            >
              Close
            </button>
          </>
        ) : (
          // Success popup (default)
          <>
            <div className="w-18 h-18 relative mb-5">
              <div className="absolute inset-0 bg-green-100 rounded-full animate-ping opacity-25"></div>
              <div className="relative w-16 h-16 bg-white rounded-full flex items-center justify-center border-2 border-green-400">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
            </div>
            <h2 className="text-xl font-bold text-green-700">Order Placed Successfully</h2>
            <p className="mt-2 text-gray-600">Your order has been placed and is being processed.</p>
            <div className="mt-4 p-3 bg-green-50 rounded-lg border border-green-200">
              <p className="text-sm text-green-800">Thank you for your order! You'll receive a confirmation shortly.</p>
            </div>
            <button 
              onClick={() => {
                setShowOrderConfirmation(false);
                navigate('/consumer/app/home');
              }}
              className="mt-5 px-5 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors"
            >
              Continue
            </button>
          </>
        )}
      </div>
    </div>
  </div>
)}

     

    </div>
  );
};

export default SummaryPage;
